/* Native forms remain usable when JavaScript is unavailable. */
(() => {
  function initializeProduct(section) {
    if (section.dataset.initialized === 'true') return;
    const select = section.querySelector('[data-variant-select]');
    const data = section.querySelector('[data-product-variants]');
    if (!select || !data) return;

    let variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (error) {
      console.error('Unable to read product variant data.', error);
      return;
    }
    section.dataset.initialized = 'true';

    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;

      section.querySelectorAll('[data-product-price]').forEach((price) => {
        price.textContent = variant.price;
      });
      section.querySelectorAll('[data-product-compare-price]').forEach((price) => {
        price.hidden = !variant.compare_at_price;
        const amount = price.querySelector('[data-compare-price-amount]') || price;
        amount.textContent = variant.compare_at_price || '';
      });
      section.querySelectorAll('[data-add-to-cart]').forEach((button) => {
        button.disabled = !variant.available;
        const text = button.querySelector('[data-add-to-cart-text]');
        const label = variant.available ? button.dataset.availableText : button.dataset.soldOutText;
        if (text) text.textContent = label;
      });
      const quantity = section.querySelector('input[name="quantity"]');
      if (quantity && variant.quantity_rule) {
        quantity.min = variant.quantity_rule.min;
        quantity.step = variant.quantity_rule.increment;
        if (variant.quantity_rule.max) quantity.max = variant.quantity_rule.max;
        else quantity.removeAttribute('max');
        quantity.value = variant.quantity_rule.min;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.featured_media_id) {
        const media = section.querySelector(`[data-media-id="${variant.featured_media_id}"]`);
        if (media) {
          media.scrollIntoView({ behavior: 'auto', block: 'nearest' });
        }
      }
      const status = document.querySelector('[data-product-status]');
      if (status) status.textContent = `${select.selectedOptions[0].textContent.trim()} — ${variant.price}`;
    });
  }

  function initialize(root) {
    if (root.matches && root.matches('[data-product-section]')) initializeProduct(root);
    root.querySelectorAll('[data-product-section]').forEach(initializeProduct);
    root.querySelectorAll('.header-menu').forEach((menu) => {
      if (menu.dataset.initialized === 'true') return;
      menu.dataset.initialized = 'true';
      const desktop = window.matchMedia('(min-width: 1180px)');
      const synchronizeMenu = () => { menu.open = desktop.matches; };
      synchronizeMenu();
      desktop.addEventListener('change', synchronizeMenu);
      menu.addEventListener('toggle', () => {
        if (desktop.matches && !menu.open) menu.open = true;
      });
      const cleanup = (event) => {
        if (!event.target.contains(menu)) return;
        desktop.removeEventListener('change', synchronizeMenu);
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    let disclosure = event.target.closest('details');
    while (disclosure) {
      disclosure.open = true;
      disclosure = disclosure.parentElement.closest('details');
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const details = document.activeElement && document.activeElement.closest('details[open]');
    if (!details) return;
    if (details.classList.contains('header-menu') && window.matchMedia('(min-width: 1180px)').matches) return;
    details.open = false;
    const summary = details.querySelector('summary');
    if (summary) summary.focus();
  });
})();
